// extracted by mini-css-extract-plugin
export default {"JsxCommentToken":"JsxCommentTokenVZ04_VecFlJV"};